import React from "react";
import AdminNavbar from "../Components/Navbar/AdminNavbar";
import AdminFooter from "../Components/Footer/AdminFooter";

const AdminLayout = ({ children }) => {
  return (
    <>
      <AdminNavbar />
      <main>{children}</main>
      <AdminFooter />
    </>
  );
};

export default AdminLayout;
